import { QuestionType } from './FormDetailsEnum';

export interface ConsentConfig {
  showConsent: boolean;
  consentLabel: string;
  required: boolean;
  checkedByDefault: boolean;
}

export interface AddressConfig {
  line1: boolean;
  line2: boolean;
  city: boolean;
  state: boolean;
  zip: boolean;
  country: boolean;
}

export interface NameConfig {
  firstName: boolean;
  lastName: boolean;
}

export interface ContentConfig {
  content: string;
}

export interface FileUploadConfig {
  cta: string;
}

export enum FieldValidationType {
  alphanumeric = 'alphanumeric',
  numeric = 'numeric',
  list = 'list',
  date = 'date',
}

export interface FieldValidation {
  type?: FieldValidationType;
  listId?: string;
  allowSpecialCharacters?: boolean;
  min?: number;
  max?: number;
  lengthLimit?: boolean;
  limitUse?: boolean;
  maxUses?: number;
  maxUsesErrorMessage?: string;
  customizeInvalidEntryMessage?: boolean;
  invalidEntryMessage?: string;
  isCaseSensitive?: boolean;
  minValue?: number;
  maxValue?: number;
  valueLimit?: boolean;
  property?: {
    enabled: boolean;
    label: string;
    name: string;
  };
  verifyAge?: {
    enabled: boolean;
    minAge: number | null;
    maxAge: number | null;
  };
  dateValidation?: {
    fixedDateWindow?: {
      enabled: boolean;
      startDate: Date;
      endDate: Date;
    };
    dynamicDateWindow?: {
      enabled: boolean;
      daysBeforeCurrentDate: number;
      daysAfterCurrentDate: number;
    };
  };
}

type SortMethod = 'alphabetical' | 'random' | 'date';

export interface SearchableDropDownConfig {
  sortingSchema: SortMethod;
  allowedCustomValue: boolean;
  listId?: string;
  limitUse?: boolean;
  maxUses?: number;
}

export interface FieldConfig {
  fieldValidation?: FieldValidation;
}

export type Config =
  | (ConsentConfig &
      NameConfig &
      AddressConfig &
      SearchableDropDownConfig &
      FieldConfig & {
        cta: string;
        content: string;
      })
  | null;
export interface FormModuleModel {
  _id: string;
  name: string;
  title: string;
  enabled: boolean;
  active: boolean;
  brand: string;
  type: string;
  content: string;
  formDetails: FormDetailModel;
  autoDeploy: boolean;
}

export interface FormDetailOptions {
  text: string;
  isDefault: boolean;
  date?: Date | string;
}

export enum PropertyDestination {
  Registration = 'registration',
  Profile = 'profile',
  Form = 'form',
}

export interface Property {
  _id?: string;
  name: string;
  destination: PropertyDestination[];
  type: string;
  brandId?: string;
  sampleValue: string;
  global: boolean;
  createdAt?: Date;
  updatedAt?: Date;
  subProperties?: Property[];
}

export interface FormDetailModel {
  _id?: string;
  type: QuestionType;
  isRequired: boolean;
  text: string;
  options: FormDetailOptions[];
  subText: string;
  isLongQuestion?: boolean;
  allowedMultiple?: boolean;
  image?: string;
  config?: Config;
  property: Property;
  subProperty?: string;
}
